import type { DmReviewRating } from "../../../app/services/dmThreads";

/**
 * レビュー評価（Good/Bad）の表示ヘルパー。
 *
 * OfferReviewModal（投稿フォームのプレビュー）と OfferReviewSection（投稿済みカード）
 * でラベル・アイコンの二重定義を防ぐために共有する。投稿は LIKE/DISLIKE のみだが、
 * 読み取り型（`DmReviewRating`）には NO_ACTION / null が含まれうるため、表示対象外は
 * `null` を返して防御的に扱う。
 */
export const reviewRatingLabel = (
  rating: DmReviewRating | null | undefined,
): string | null => {
  if (rating === "LIKE") return "良かった";
  if (rating === "DISLIKE") return "残念だった";
  return null;
};

export const reviewRatingIcon = (
  rating: DmReviewRating | null | undefined,
): string | null => {
  if (rating === "LIKE") return "thumb_up";
  if (rating === "DISLIKE") return "thumb_down";
  return null;
};
